/**
 * Vendors can be found on the SourcePoint dashboard page
 * https://analytics.sourcepoint.com/consent_v2/vendor_lists
 */
export enum SOURCE_POINT_VENDOR {
  SOURCE_POINT = '5ea2d4894e5aa15059fde8a0',
  FIREBASE_ANALYTICS = '5f6123d6c35b51195c3e17be',
  FIREBASE_CRASHLYTICS = '5e68f9f669e7a93e0b25906d',
  GOOGLE_ANALYTICS = '5e542b3a4cd8884eb41b5a72',
}

enum FIREBASE_ANALYTICS_PURPOSES_IOS {
  STORE_AND_ACCESS_INFORMATION_ON_DEVICE = '622b80158b8728081a33fd1f',
  CREATE_PERSONALIZED_ADS_PROFILE = '622b80158b8728081a33fd29',
  SELECT_PERSONALIZED_ADS = '622b80158b8728081a33fd2e',
  MEASURE_AD_PERFORMANCE = '622b80158b8728081a33fd3d',
  ANALYTICS_STORAGE = '65d76d95994ed10677a9a8e2',
}

enum FIREBASE_ANALYTICS_PURPOSES_ANDROID {
  STORE_AND_ACCESS_INFORMATION_ON_DEVICE = '622b7fb05416b00754e7f973',
  CREATE_PERSONALIZED_ADS_PROFILE = '622b7fb05416b00754e7f97d',
  SELECT_PERSONALIZED_ADS = '622b7fb05416b00754e7f982',
  MEASURE_AD_PERFORMANCE = '622b7fb05416b00754e7f991',
  ANALYTICS_STORAGE = '65d76d570bcf2204e524bcee',
}

export function getFirebaseAnalyticsPurposes(platform: 'ios' | 'android') {
  return platform === 'ios' ? FIREBASE_ANALYTICS_PURPOSES_IOS : FIREBASE_ANALYTICS_PURPOSES_ANDROID;
}
